var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-block"},[(_vm.imgName)?_c('img',{attrs:{"src":require('@/assets/images/' + _vm.imgName + ''),"alt":_vm.imgAlt}}):_vm._e(),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }